import { useEffect, useState } from "react";
import { plans as fallbackPlans } from "@yunliu/shared";
import { userApi, type PublicPlan } from "../lib/api";

const fallback: PublicPlan[] = fallbackPlans.map((plan) => ({
  ...plan,
  trafficBytes: plan.trafficGb * 1024 ** 3,
  priceMinor: Math.round(plan.priceCny * 100),
  originalPriceCny: null,
  originalPriceMinor: null,
  maxDevices: 3,
  recommended: Boolean(plan.recommended),
  billingPeriod: plan.validityDays === 90 ? "quarterly" : plan.validityDays === 365 ? "yearly" : plan.validityDays === 30 ? "monthly" : "custom",
  cardBadge: null,
  features: ["高速国内节点", "智能应用分流", "全平台客户端", "清晰使用记录"],
}));

export function usePublicPlans() {
  const [plans, setPlans] = useState<PublicPlan[]>(fallback);
  const [online, setOnline] = useState(false);
  useEffect(() => { const controller = new AbortController(); userApi.plans().then((value) => { if (!controller.signal.aborted) { setPlans(value); setOnline(true); } }).catch(() => undefined); return () => controller.abort(); }, []);
  return { plans, online };
}
